import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import TimePicker from "rc-time-picker";
import {useAxiosInterceptor} from "src/hooks/useAxiosInterceptor";
import {useAuth} from "src/contexts/auth-provider";
import {GRAPHQL_ENDPOINT, S3_BASE_URL} from "src/constants/endpoints";
import {STORES} from "src/constants/queries";
import {BtnLoader} from "src/Loader/index";
import {UPDATE_RESTAURANT, UPLOAD_RESTAURANT_IMAGE,} from "../../constants/mutations";
import {failureToast, successToast} from "src/utils/toasts";
import {convertMomentToSeconds, convertSecondsToMoment, formatSecondsToDisplayTime} from "src/utils/date";
import Dropzone from "react-dropzone";
import axios from "axios";
import RestuarantImg from "../../assests/images/dashboard/test.png";
import FormSkeletonLoader from "./FormLoading";
import TimePickerSkeletonLoader from "./TimePickerLoader";

export const mimeTypeToExtension: any = {
  "image/png": "png",
  "image/jpg": "jpg",
  "image/jpeg": "jpeg",
};

type GeneralTab = "profile" | "hours";

interface RestaurantSettingComponentProps {
  tab: GeneralTab;
}

const RestaurantSettingComponent = ({ tab }: RestaurantSettingComponentProps) => {
  const [imageUrl, setImageUrl] = useState<string>("");
  const formik = useFormik({
    initialValues: {
      restaurantName: "",
      street: "",
      stateProvince: "",
      city: "",
      zipCode: "",
      email: "",
      firstName: "",
      lastName: "",
      contactNumber: "",
      style:"",
      operationMode: "STANDARD",
      time: [
        { day: "MONDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "TUESDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "WEDNESDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "THURSDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "FRIDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "SATURDAY", endHour: 0, startHour: 0, isSelected: false },
        { day: "SUNDAY", endHour: 0, startHour: 0, isSelected: false },
      ],
    },
    validationSchema: Yup.object({
      restaurantName: Yup.string().required("Restaurant is Required"),
      street: Yup.string().required("Street is Required"),
      stateProvince: Yup.string().required("State is Required"),
      city: Yup.string().required("City is Required"),
      zipCode: Yup.string().required("Zipcode is Required"),
      email: Yup.string()
        .email("Invalid Email address")
        .required("Email is Required"),
      firstName: Yup.string().required("First name is Required"),
      lastName: Yup.string().required("Last name is Required"),
      contactNumber: Yup.number().required("Contact number is Required"),
    }),

    onSubmit: () => {},
  });
  const format = "hh:mm a";
  const minuteStep = 10;
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant, setRestaurantData } = useAuth();
  const [timeInProgress, setTimeInProgress] = useState(false);
  const [generalInProgress, setGeneralInProgress] = useState(false);
  const { user } = useAuth();
  const [uploadImage, setUploadImage] = useState<any>(null);
  const [uploadImageLoader, setUploadImageLoader] = useState(false);
  const [loading, setloading] = useState(false);
  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const [editContactOpen, setEditContactOpen] = useState(false);
  const [editHoursOpen, setEditHoursOpen] = useState(false);

  const handleCheckboxChange = (index: any) => {
    const newSelection = !formik.values.time[index].isSelected;
    formik.setFieldValue(`time[${index}].isSelected`, newSelection);
  };

  const updateRestaurantSetting = async () => {
    try {
      const updatedTime = formik.values?.time?.map((item) => {
        return {
          day: item.day,
          startTimeInSeconds: item.startHour || 0,
          endTimeInSeconds: item.endHour || 0,
        };
      });

      const payload: any = {
        name: formik.values.restaurantName,
        primaryContactFirstName: formik.values.firstName,
        primaryContactLastName: formik.values.lastName,
        primaryContactEmail: user.storeUser.email,
        style: formik.values.style,
        operationMode: formik.values.operationMode,
        primaryContactPhoneNumber: formik.values.contactNumber?.toString(),
        address: {
          addressLine1: formik.values.street,
          city: formik.values.city,
          state: formik.values.stateProvince,
          zipCode: formik.values.zipCode,
        },
        operationHours: updatedTime,
      };

      const variables = {
        updateStoreInput: {
          ...payload,
          storeCorrelationId: hasRestaurant.correlationId,
        },
      };

      await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_RESTAURANT,
        variables: variables,
      });

      setGeneralInProgress(false);
      setTimeInProgress(false);
      fetchStores();
      successToast("Restaurant has been Updated!");
    } catch (error) {
      console.error("Error updating restaurant:", error);
      setGeneralInProgress(false);
      setTimeInProgress(false);
    }
  };

  useEffect(() => {
    setloading(true);
    fetchStores(true);
  }, []);

  const fetchStores = async (isPatchValues = false, restuarant = {}) => {
    try {
      const response: any = await axBe.post(GRAPHQL_ENDPOINT, {
        query: STORES,
        variables: {
          retrieveStoresInput: {
            storeCorrelationIds: [hasRestaurant.correlationId],
          },
        },
      });
      const { data }: any = response.data;
      if (data?.stores && data.stores.length > 0) {
        const info: any = data?.stores?.[0];
        setRestaurantData({...info, ...restuarant});
        if (!isPatchValues) {
          return;
        }
        formik.setFieldValue("restaurantName", info.name);
        formik.setFieldValue(
          "restaurantNameOtherLanguage",
          info.nonEnglishName
        );
        formik.setFieldValue("street", info.address?.addressLine1);
        formik.setFieldValue("stateProvince", info.address?.state);
        formik.setFieldValue("city", info.address?.city);
        formik.setFieldValue("zipCode", info.address?.zipCode);
        formik.setFieldValue("email", info.primaryContactEmail);
        formik.setFieldValue("firstName", info.primaryContactFirstName);
        formik.setFieldValue("lastName", info.primaryContactLastName);
        formik.setFieldValue("contactNumber", info.primaryContactPhoneNumber);
        formik.setFieldValue("style", info.style);
        formik.setFieldValue("operationMode", info.operationMode || "STANDARD");
        formik.setFieldValue(
          "time",
          info.operationHours?.map((time: any) => {
            return {
              ...time,
              startHour: time.startTimeInSeconds || 0,    // Changed from time.startHour
              endHour: time.endTimeInSeconds || 0,        // Changed from time.endHour
              isSelected: !!time?.startTimeInSeconds || !!time?.endTimeInSeconds, // Updated field name
            };
          })
        );
        setTimeout(() => {
          formik.setFieldValue(
            "contactNumber",
            info.primaryContactPhoneNumber
          );
        }, 5);
        setloading(false);
        if (info?.bucketKeyName) {
          setImageUrl(S3_BASE_URL + info?.bucketKeyName);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const uploadRestaurantImage = async (selectedImage = uploadImage) => {
    if (!selectedImage?.file) return;
    const fileNameExtension = mimeTypeToExtension[selectedImage.file.type];
    if (!fileNameExtension) {
      failureToast("Store logo must be a PNG or JPEG image.");
      return;
    }

    setUploadImageLoader(true);
    const variables = {
      createStorePreSignedUrlInput: {
        storeUserCorrelationId: user?.storeUser?.correlationId,
        storeName: hasRestaurant?.name,
        fileNameExtension,
        storeCorrelationId: hasRestaurant?.correlationId,
      },
    };
    try {
      const res = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPLOAD_RESTAURANT_IMAGE,
        variables: variables,
      });
      if (!res?.data?.error?.length) {
        const awsUrl =
          res.data?.data?.createUploadPreSignedUrlForStore?.preSignedUrl;

        await axios.put(awsUrl, selectedImage.file, {
          headers: {
            "Content-Type": selectedImage.file.type,
            "x-amz-acl": "public-read",
          },
        });
        setImageUrl(selectedImage.url);
        setUploadImage(null);
        fetchStores(false, {bucketKeyName: selectedImage.url});
        successToast("Image successfully uploaded");
        setUploadImageLoader(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploadImageLoader(false);
    }
  };

  const handleFileChange = (file: any) => {
    if (!mimeTypeToExtension[file?.type]) {
      failureToast("Store logo must be a PNG or JPEG image.");
      return;
    }

    const selectedImage = {
      url: URL.createObjectURL(file),
      file,
    };

    setUploadImage(selectedImage);
    uploadRestaurantImage(selectedImage);
  };

  const applyMondayHoursToAll = () => {
    const monday = formik.values.time?.[0];
    if (!monday) return;
    const newTime = formik.values.time?.map((_, i) => ({
      ...formik.values.time[i],
      startHour: monday.startHour,
      endHour: monday.endHour,
      isSelected: monday.isSelected,
    })) ?? [];
    formik.setFieldValue("time", newTime);
  };

  const setAllDaysClosed = () => {
    const newTime = formik.values.time?.map((t) => ({ ...t, isSelected: false, startHour: 0, endHour: 0 })) ?? [];
    formik.setFieldValue("time", newTime);
  };

  const copyWeekdaysToWeekend = () => {
    const mon = formik.values.time?.[0];
    if (!mon) return;
    const newTime = [...(formik.values.time ?? [])];
    if (newTime[5]) newTime[5] = { ...newTime[5], startHour: mon.startHour, endHour: mon.endHour, isSelected: mon.isSelected };
    if (newTime[6]) newTime[6] = { ...newTime[6], startHour: mon.startHour, endHour: mon.endHour, isSelected: mon.isSelected };
    formik.setFieldValue("time", newTime);
  };

  type HoursSummary = { weekdays: string | null; weekend: string | null; exceptions: string[] };
  const getHoursSummary = (): HoursSummary => {
    const time = formik.values.time ?? [];
    const dayNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const weekdays = time.slice(0, 5);
    const weekend = time.slice(5, 7);
    const sameRange = (a: { startHour: number; endHour: number; isSelected: boolean }, b: typeof a) =>
      a.isSelected === b.isSelected && a.startHour === b.startHour && a.endHour === b.endHour;
    const rangeStr = (t: { startHour: number; endHour: number; isSelected: boolean }) =>
      t.isSelected ? `${formatSecondsToDisplayTime(t.startHour)} – ${formatSecondsToDisplayTime(t.endHour)}` : "Closed";
    let weekdaysStr: string | null = null;
    if (weekdays.length && weekdays.every((t) => sameRange(t, weekdays[0]))) {
      weekdaysStr = weekdays[0].isSelected ? `${formatSecondsToDisplayTime(weekdays[0].startHour)} – ${formatSecondsToDisplayTime(weekdays[0].endHour)}` : "Closed";
    }
    let weekendStr: string | null = null;
    if (weekend.length === 2 && sameRange(weekend[0], weekend[1])) {
      weekendStr = weekend[0].isSelected ? `${formatSecondsToDisplayTime(weekend[0].startHour)} – ${formatSecondsToDisplayTime(weekend[0].endHour)}` : "Closed";
    }
    const exceptions: string[] = [];
    time.forEach((t, i) => {
      const name = dayNames[i];
      if (!t.isSelected) exceptions.push(`${name} closed`);
      else if (i < 5 && !weekdaysStr) exceptions.push(`${name}: ${rangeStr(t)}`);
      else if (i >= 5 && !weekendStr) exceptions.push(`${name}: ${rangeStr(t)}`);
    });
    return { weekdays: weekdaysStr, weekend: weekendStr, exceptions };
  };

  /** Group consecutive days with same schedule for the hours list. Single day: "Mon"; range: "Wed–Sun" (no spaces around dash). */
  type HoursListRow = { dayLabel: string; closed: boolean; timeRange: string | null };
  const getHoursListGrouped = (): HoursListRow[] => {
    const time = formik.values.time ?? [];
    const dayNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const same = (a: { startHour: number; endHour: number; isSelected: boolean }, b: typeof a) =>
      a.isSelected === b.isSelected && a.startHour === b.startHour && a.endHour === b.endHour;
    const rows: HoursListRow[] = [];
    let i = 0;
    while (i < time.length) {
      const t = time[i];
      let end = i;
      while (end + 1 < time.length && same(time[end + 1], t)) end++;
      const dayLabel = end === i ? dayNames[i] : `${dayNames[i]}–${dayNames[end]}`;
      const closed = !t.isSelected;
      const timeRange = t.isSelected ? `${formatSecondsToDisplayTime(t.startHour)} – ${formatSecondsToDisplayTime(t.endHour)}` : null;
      rows.push({ dayLabel, closed, timeRange });
      i = end + 1;
    }
    return rows;
  };

  const addressPreview =
    [formik.values.street, formik.values.city, [formik.values.stateProvince, formik.values.zipCode].filter(Boolean).join(" ")]
      .filter(Boolean)
      .join(", ") || "No address set";
  const contactName = [formik.values.firstName, formik.values.lastName].filter(Boolean).join(" ") || "";
  const contactRest = [formik.values.contactNumber, formik.values.email].filter(Boolean).join(" • ") || "";
  const contactPreviewLine = [contactName, contactRest].filter(Boolean).join(" • ") || "No contact set";

  const inputClass =
    "h-10 w-full rounded-[12px] border border-[#e5e7eb] bg-white px-3 text-sm text-[#111827] placeholder:text-[#9ca3af] focus:border-[#FD7657] focus:outline-none focus:ring-2 focus:ring-[#FD7657]/20 transition-shadow";
  const labelClass = "text-[13px] font-medium text-[#6b7280] mb-1 block";

  const summary = getHoursSummary();
  const Drawer = ({ open, onClose, title, children }: { open: boolean; onClose: () => void; title: string; children: React.ReactNode }) => (
    <>
      {open && <div className="fixed inset-0 z-40 bg-black/60" aria-hidden onClick={onClose} />}
      <div className={`fixed top-0 right-0 z-50 h-full w-full max-w-md bg-white shadow-xl flex flex-col transition-transform duration-200 ${open ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex items-center justify-between p-4 border-b border-[#e5e7eb]">
          <h3 className="text-lg font-semibold text-[#111827]">{title}</h3>
          <button type="button" className="p-2 text-[#6b7280] hover:text-[#111827] hover:bg-[#f3f4f6] rounded-[10px]" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </div>
    </>
  );

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-6 lg:gap-8 min-w-0">
          {/* Profile tab: same content column and card style as Hours */}
          {tab === "profile" && (
            <div className="w-full min-w-0 lg:col-span-2">
              <div className="w-full max-w-[760px] min-w-0">
                <div className="bg-[#ffffff] rounded-[16px] px-4 py-4 sm:px-6 sm:py-5 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_rgba(0,0,0,0.08)]">
                  <h2 className="text-[18px] font-semibold text-[#111827] tracking-[-0.02em] mb-4">Restaurant Profile</h2>
                  {loading ? (
                    <FormSkeletonLoader />
                  ) : (
                    <div className="space-y-0">
                      <div className="flex flex-col gap-4 sm:flex-row sm:items-center pb-4">
                        <Dropzone
                          accept={{ "image/png": [".png"], "image/jpg": [".jpg"], "image/jpeg": [".jpeg"] }}
                          disabled={uploadImageLoader}
                          onDrop={(acceptedFiles) => acceptedFiles[0] && handleFileChange(acceptedFiles[0])}
                          onDropRejected={() => failureToast("Store logo must be a PNG or JPEG image.")}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              className={`group relative h-20 w-20 shrink-0 rounded-full border-2 border-[#f3f4f6] bg-[#f9fafb] transition-colors ${uploadImageLoader ? "cursor-wait" : "cursor-pointer hover:border-[#d1d5db]"}`}
                              title={imageUrl ? "Change logo" : "Upload logo"}
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="absolute inset-0 overflow-hidden rounded-full">
                                <img className="h-full w-full object-cover" src={uploadImage?.url || imageUrl || RestuarantImg} alt="" />
                                <div className={`absolute inset-0 flex items-center justify-center bg-black/20 transition-opacity ${uploadImageLoader ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}>
                                  {uploadImageLoader ? (
                                    <div className="h-6 w-6 animate-spin rounded-full border-2 border-white/50 border-t-white" />
                                  ) : null}
                                </div>
                              </div>
                              <span className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full border border-[#e5e7eb] bg-white text-[#4b5563] shadow-[0_4px_12px_rgba(0,0,0,0.16)] transition-colors group-hover:text-[#111827]" aria-hidden="true">
                                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16.862 4.487l1.651-1.651a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.5 7.125L16.875 4.5" />
                                </svg>
                              </span>
                            </div>
                          )}
                        </Dropzone>
                        <div className="flex-1 min-w-0 w-full">
                          <label htmlFor="restaurantName" className={labelClass}>Restaurant Name</label>
                          <input id="restaurantName" name="restaurantName" className={inputClass} placeholder="Restaurant Name" value={formik.values.restaurantName} onBlur={formik.handleBlur} onChange={formik.handleChange} />
                          {formik.touched.restaurantName && formik.errors.restaurantName ? <p className="text-xs text-[#FD7657] mt-1">{formik.errors.restaurantName}</p> : null}
                          <div className="mt-2">
                            {uploadImageLoader ? (
                              <span className="text-[14px] font-medium text-[#6b7280]">Uploading logo…</span>
                            ) : null}
                            <p className="mt-1 text-[12px] font-medium text-[#9ca3af]">PNG or JPEG only.</p>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3 py-2 border-t border-[#f3f4f6]">
                        <p className="text-[14px] font-medium text-[#4b5563] break-words flex-1 min-w-0">{addressPreview}</p>
                        <button type="button" className="text-[13px] font-medium text-[#6b7280] bg-transparent border-none cursor-pointer hover:text-[#111827] focus:outline-none shrink-0 self-start sm:pt-0.5" onClick={() => setEditAddressOpen(true)}>Edit</button>
                      </div>
                      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3 py-2 border-t border-[#f3f4f6]">
                        <p className="text-[14px] font-medium text-[#4b5563] break-words flex-1 min-w-0">{contactPreviewLine}</p>
                        <button type="button" className="text-[13px] font-medium text-[#6b7280] bg-transparent border-none cursor-pointer hover:text-[#111827] focus:outline-none shrink-0 self-start sm:pt-0.5" onClick={() => setEditContactOpen(true)}>Edit</button>
                      </div>
                      <div className="flex flex-col gap-3 py-4 border-t border-[#f3f4f6]">
                        <label className="flex items-start gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={formik.values.operationMode === "QUICK_SERVICE"}
                            onChange={(event) => formik.setFieldValue("operationMode", event.target.checked ? "QUICK_SERVICE" : "STANDARD")}
                            className="receipt-lang-check mt-0.5 h-6 w-6 min-h-[24px] min-w-[24px] shrink-0 rounded border border-[#9B9B9B] cursor-pointer appearance-none"
                          />
                          <div className="min-w-0">
                            <p className="text-[14px] font-semibold text-[#111827]">Quick service mode</p>
                            <p className="mt-1 text-[13px] leading-5 text-[#6b7280]">
                              Use this for ready-to-serve combo flows. The POS Pick Up tile opens a combo builder instead of the standard order setup.
                            </p>
                          </div>
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Hours tab: content column aligned with tab strip (760px, no floating center) */}
          {tab === "hours" && (
            <div className="w-full min-w-0 lg:col-span-2">
              <div className="w-full max-w-[760px] min-w-0 space-y-3">
              <div className="bg-[#ffffff] rounded-[16px] px-4 py-4 sm:px-6 sm:py-5 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_rgba(0,0,0,0.08)]">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
                  <h2 className="text-[18px] font-semibold text-[#111827] tracking-[-0.02em]">Business Hours</h2>
                  <button
                    type="button"
                    className="text-[13px] font-medium text-[#9ca3af] rounded-lg px-2.5 py-1.5 -mr-1 border-0 bg-transparent cursor-pointer hover:text-[#6b7280] hover:bg-[#f3f4f6] focus:outline-none transition-colors"
                    onClick={() => setEditHoursOpen(true)}
                  >
                    Edit hours
                  </button>
                </div>
                {loading ? (
                  <TimePickerSkeletonLoader />
                ) : (
                  <div className="flex flex-col">
                    {getHoursListGrouped().length === 0 ? (
                      <p className="text-[14px] text-[#9ca3af] py-1">No hours set</p>
                    ) : (
                      getHoursListGrouped().map((row, idx) => (
                        <div key={idx} className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between py-3 border-b border-[#e5e7eb] last:border-b-0 last:pb-0 min-w-0">
                          <span className="text-[14px] font-medium text-[#4b5563] w-full sm:w-[7rem] sm:shrink-0">{row.dayLabel}</span>
                          {row.closed ? (
                            <span className="text-xs font-medium py-1 px-2.5 rounded-full bg-[#f3f4f6] text-[#6b7280] self-start sm:self-auto">Closed</span>
                          ) : (
                            <span className="text-[14px] font-medium text-[#374151] break-words text-left sm:text-right min-w-0">
                              {row.timeRange?.split(" – ").map((part, i) => (
                                <span key={i}>
                                  {i > 0 && <span className="text-[#9ca3af] font-medium mx-1.5">–</span>}
                                  {part}
                                </span>
                              ))}
                            </span>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>

              {/* Special Dates — placeholder */}
              <div className="bg-[#ffffff] rounded-[16px] px-4 py-4 sm:px-6 sm:py-5 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_rgba(0,0,0,0.08)]">
                <h2 className="text-[18px] font-semibold text-[#111827] tracking-[-0.02em] mb-4">Special Dates</h2>
                <p className="text-[14px] text-[#6b7280] mb-4">No special hours configured.</p>
                <button
                  type="button"
                  className="text-[14px] font-medium text-[#111827] underline bg-transparent border-none cursor-pointer hover:text-[#374151] focus:outline-none"
                >
                  Add special hours
                </button>
              </div>
              </div>
            </div>
          )}
        </div>

      {/* Sticky Save footer — full width on small screens, capped width on large */}
      <div className="sticky bottom-0 left-0 right-0 z-10 w-full min-w-0 mt-6">
        <div className="w-full max-w-[760px] py-3 px-4 sm:px-6 bg-[#f1f3f5] border-t border-[#e5e7eb] flex flex-wrap items-center justify-end gap-3 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]">
            {generalInProgress || timeInProgress ? (
              <BtnLoader />
            ) : (
              <>
                <button type="button" className="text-sm font-medium text-[#6b7280] hover:text-[#374151]" onClick={() => fetchStores(true)}>Cancel</button>
                <button type="button" className="px-5 py-2.5 rounded-xl bg-[#FD7657] text-white text-sm font-semibold hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[#FD7657]/20 focus:ring-offset-2" onClick={() => { setGeneralInProgress(true); setTimeInProgress(true); updateRestaurantSetting(); }}>Save Changes</button>
              </>
            )}
          </div>
        </div>

      {/* Edit Address drawer — only relevant when tab is profile */}
      <Drawer open={editAddressOpen} onClose={() => setEditAddressOpen(false)} title="Edit Address">
        <div className="space-y-4">
          <div><label className={labelClass}>Street</label><input className={inputClass} name="street" value={formik.values.street} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.street && formik.errors.street && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.street}</p>}</div>
          <div className="grid grid-cols-2 gap-4"><div><label className={labelClass}>City</label><input className={inputClass} name="city" value={formik.values.city} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.city && formik.errors.city && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.city}</p>}</div><div><label className={labelClass}>State / Province</label><input className={inputClass} name="stateProvince" value={formik.values.stateProvince} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.stateProvince && formik.errors.stateProvince && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.stateProvince}</p>}</div></div>
          <div className="grid grid-cols-2 gap-4"><div><label className={labelClass}>Zip code</label><input className={inputClass} name="zipCode" value={formik.values.zipCode} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.zipCode && formik.errors.zipCode && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.zipCode}</p>}</div><div><label className={labelClass}>Style</label><input className={inputClass} name="style" value={formik.values.style} onChange={formik.handleChange} /></div></div>
          <div className="flex gap-3 pt-4"><button type="button" className="flex-1 py-2.5 rounded-xl border border-[#e5e7eb] text-sm font-medium text-[#374151] hover:bg-[#f9fafb]" onClick={() => setEditAddressOpen(false)}>Cancel</button><button type="button" className="flex-1 py-2.5 rounded-xl bg-[#FD7657] text-white text-sm font-semibold" onClick={() => setEditAddressOpen(false)}>Done</button></div>
        </div>
      </Drawer>

      {/* Edit Contact drawer */}
      <Drawer open={editContactOpen} onClose={() => setEditContactOpen(false)} title="Edit Contact">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className={labelClass}>First Name</label><input className={inputClass} name="firstName" value={formik.values.firstName} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.firstName && formik.errors.firstName && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.firstName}</p>}</div>
            <div><label className={labelClass}>Last Name</label><input className={inputClass} name="lastName" value={formik.values.lastName} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.lastName && formik.errors.lastName && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.lastName}</p>}</div>
          </div>
          <div><label className={labelClass}>Contact Number</label><input className={inputClass} type="number" name="contactNumber" value={formik.values.contactNumber} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.contactNumber && formik.errors.contactNumber && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.contactNumber}</p>}</div>
          <div><label className={labelClass}>Email Address</label><input className={inputClass} type="email" name="email" value={formik.values.email} onBlur={formik.handleBlur} onChange={formik.handleChange} />{formik.touched.email && formik.errors.email && <p className="text-xs text-[#FD7657] mt-1">{formik.errors.email}</p>}</div>
          <div className="flex gap-3 pt-4"><button type="button" className="flex-1 py-2.5 rounded-xl border border-[#e5e7eb] text-sm font-medium text-[#374151] hover:bg-[#f9fafb]" onClick={() => setEditContactOpen(false)}>Cancel</button><button type="button" className="flex-1 py-2.5 rounded-xl bg-[#FD7657] text-white text-sm font-semibold" onClick={() => setEditContactOpen(false)}>Done</button></div>
        </div>
      </Drawer>

      {/* Edit Hours drawer */}
      <Drawer open={editHoursOpen} onClose={() => setEditHoursOpen(false)} title="Edit Business Hours">
        <div className="space-y-4">
          <div className="flex flex-wrap gap-2">
            <button type="button" className="text-sm font-medium text-[#FD7657] hover:underline" onClick={applyMondayHoursToAll}>Apply Monday to all days</button>
            <button type="button" className="text-sm font-medium text-[#6b7280] hover:underline" onClick={copyWeekdaysToWeekend}>Copy weekdays to weekend</button>
            <button type="button" className="text-sm font-medium text-[#6b7280] hover:underline" onClick={setAllDaysClosed}>Set all closed</button>
          </div>
          <div className="flex flex-col border-t border-[#f3f4f6] pt-4">
            {formik.values?.time?.map((item, index) => (
              <div key={item.day} className="flex items-center justify-between py-2.5 border-b border-[#f3f4f6] last:border-b-0 gap-3">
                <span className={`text-sm font-medium w-24 shrink-0 ${item.isSelected ? "text-[#111827]" : "text-[#9ca3af]"}`}>{item.day.charAt(0) + item.day.slice(1).toLowerCase()}</span>
                <div className="flex items-center gap-2 shrink-0">
                  <button type="button" role="switch" aria-checked={item.isSelected} className={`relative inline-flex h-6 w-11 shrink-0 rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-[#FD7657]/20 ${item.isSelected ? "bg-[#FD7657] border-[#FD7657]" : "bg-[#e5e7eb] border-[#e5e7eb]"}`} onClick={() => handleCheckboxChange(index)}><span className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform mt-0.5 ml-0.5 ${item.isSelected ? "translate-x-5" : "translate-x-0"}`} /></button>
                  <span className="text-sm text-[#6b7280] w-12">{item.isSelected ? "Open" : "Closed"}</span>
                </div>
                <div className="flex items-center gap-2 min-w-0 flex-1 justify-end">
                  {item.isSelected ? (
                    <div className="flex items-center gap-2">
                      <TimePicker minuteStep={minuteStep} showSecond={false} defaultValue={convertSecondsToMoment(item.startHour)} onChange={(v) => formik.setFieldValue(`time[${index}].startHour`, v && v.isValid() ? convertMomentToSeconds(v) : 0)} format={format} allowEmpty={false} use12Hours={true} />
                      <span className="text-[#9ca3af] text-sm">—</span>
                      <TimePicker minuteStep={minuteStep} showSecond={false} defaultValue={convertSecondsToMoment(item.endHour)} onChange={(v) => formik.setFieldValue(`time[${index}].endHour`, v && v.isValid() ? convertMomentToSeconds(v) : 0)} format={format} allowEmpty={false} use12Hours={true} />
                    </div>
                  ) : <span className="text-sm text-[#9ca3af]">Closed</span>}
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-3 pt-4"><button type="button" className="flex-1 py-2.5 rounded-xl border border-[#e5e7eb] text-sm font-medium text-[#374151] hover:bg-[#f9fafb]" onClick={() => setEditHoursOpen(false)}>Cancel</button><button type="button" className="flex-1 py-2.5 rounded-xl bg-[#FD7657] text-white text-sm font-semibold" onClick={() => setEditHoursOpen(false)}>Done</button></div>
        </div>
      </Drawer>
    </>
  );
};

export default RestaurantSettingComponent;
